
export default {
  setRoute ({ commit }, data) {
    commit('SET_ROUTE', data)
  },
  setDrawer ({ commit }, data) {
    commit('SET_DRAWER', data)
  },
  setRole ({ commit }, data) {
    commit('SET_ROLE', data)
  },
  setAlert ({ commit }, data) {
    commit('SET_ALERT', data)
  },
  setUser ({ commit }, data) {
    commit('SET_USER', data)
  },
  setDialog ({ commit }, data) {
    commit('SET_DIALOG', data)
  },
  setLang ({ commit }, data) {
    commit('SET_LANG', data)
  },
  setStatistic ({ commit }, data) {
    commit('SET_STATISTIC', data)
  },
  setLoading ({ commit }, data) {
    commit('SET_LOADING', data)
  },
  setWebsite ({ commit }, data) {
    commit('SET_WEBSITE', data)
  },
  setNewSubscriberDialog ({ commit }, data) {
    commit('SET_NEW_SUBSCRIBER_DIALOG', data)
  },
  setUpdateSubscriberDialog ({ commit }, data) {
    commit('SET_UPDATE_SUBSCRIBER_DIALOG', data)
  },
  setSubscriber ({ commit }, data) {
    commit('SET_SUBSCRIBER', data)
  },
  logout ({ commit }, data) {
    commit('SET_ROLE', null)
    commit('SET_USER', null)
    commit('SET_ALERT', data)
  }
}
